/**
 * Mounted Folder Scan Service
 *
 * Triggers async recursive scans for mounted folders via IPC,
 * updating the in-memory index store with results.
 */

import { useMountedFolderIndexStore } from '../store/mountedFolderIndexStore';
import type { MountedFolder } from '../types/scriptBrowserTypes';
import { scanScriptBrowserDirectory } from './scriptBrowserIpcApi';

/** Scan a single mounted folder and update the index store. */
export async function scanMountedFolder(folder: MountedFolder): Promise<void> {
  const indexStore = useMountedFolderIndexStore.getState();

  // Mark as scanning
  indexStore.addScanningFolder(folder.id);

  try {
    const result = await scanScriptBrowserDirectory({
      directoryPath: folder.directoryPath,
    });

    if (result.success) {
      useMountedFolderIndexStore
        .getState()
        .setFolderIndex(folder.id, result.sqlFiles ?? []);
    }
  } catch (error) {
    console.error(
      `[ScriptBrowser] scan failed for ${folder.directoryPath}:`,
      error
    );
  } finally {
    useMountedFolderIndexStore.getState().removeScanningFolder(folder.id);
  }
}

/** Scan all mounted folders in a list. */
export async function scanAllMountedFolders(
  folders: MountedFolder[]
): Promise<void> {
  await Promise.all(folders.map(scanMountedFolder));
}
